import Highcharts from 'highcharts';
import ExportData from 'highcharts/modules/export-data';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import { useEffect, useMemo } from 'react';
import chartConstants from "../../../../platform_common_constants/chart_constants.json"


const useChartExporter = (props) => {
  const {
    allowExport,
    eventName,
    chartProvider,
    chartRef
  } = props;

  useMemo(() => {
    Exporting(Highcharts);
    OfflineExporting(Highcharts);
    ExportData(Highcharts);
  }, []);

  const getChartObject = () => {
    if(chartProvider) return chartProvider();
    else if(chartRef) return chartRef.current.chart
  }

  const chartExportListener = (event) => {
    const chart = getChartObject()
    if(!allowExport || !chart) return;

    switch (event.detail.as) {
      case chartConstants.EXPORT_TYPE.PNG:
        chart.exportChartLocal();
        break;
      case chartConstants.EXPORT_TYPE.CSV:
        chart.downloadCSV();
        break;
    }
  }

  useEffect(() => {
    allowExport && document.addEventListener(eventName, chartExportListener);
    return () => {
      allowExport && document.removeEventListener(eventName, chartExportListener);
    }
  }, []);

  return {
    chartOptions: {
      exporting: {
        scale: 2,
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      }
    }
  }
};

export default useChartExporter;